export const TITLE_MAX = 100
export const REVIEW_MAX = 1500
export const REVIEW_MIN = 100
export const REVIEWS_ON_PAGE = 5